import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { TrialInsightsState } from './trial-insights-store.model';

const initState = () => {
  return {
    data: null,
    isLoading: true,
    isLoadingRemaining: true,
  };
};

const initBVACompareMenuState = () => {
  return {
    ...initState(),
    snapshotName: null,
    vendorId: null,
  };
};

const initPaymentMilestone = () => {
  return {
    ...initState(),
    chartData: [],
    totalMilestones: 0,
  };
};

const initRemainingSpend = () => {
  return {
    ...initState(),
    totalRemainingSpend: 0,
  };
};

export function createInitialState(): TrialInsightsState {
  return {
    bvaChart: initBVACompareMenuState(),
    currentOpenMonth: null,
    investigatorCost: initState(),
    patientCost: initState(),
    patientEnrolled: initState(),
    paymentMilestone: initPaymentMilestone(),
    remainingSpend: initRemainingSpend(),
    screenFail: initState(),
    siteCost: initState(),
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'trialInsights', resettable: true })
export class TrialInsightsStore extends Store<TrialInsightsState> {
  constructor() {
    super(createInitialState());
  }
}
